// extracted by mini-css-extract-plugin
export default {"container":"Technologies_container__rgu8f","dark":"Technologies_dark__pk82k","containerHeading":"Technologies_containerHeading__acTib"};